// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Chỉ áp dụng ẩn nút "X" khi component A mở */
.gm-ui-hover-effect {
    display: none !important;
}

.scrollable-div {
    overflow-x: auto;
    position: relative;
}

.scrollable-div.scrollable::after {
    content: '';
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    width: 20px;
    background: linear-gradient(to right, rgba(255, 255, 255, 0), rgba(0, 0, 0, 0.1));
}

.scrollable-div.not-scrollable::after {
    display: none;
}

.row-selected {
    background-color: #aed1ef !important;
    border-color: yellow !important;
    /* Màu nền tùy chỉnh cho hàng được chọn */
    /* Màu viền tùy chỉnh cho hàng được chọn */
}`, "",{"version":3,"sources":["webpack://./src/pages/Operate/EmployeeRouteTracking/style.css"],"names":[],"mappings":"AAAA,8CAA8C;AAC9C;IACI,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,SAAS;IACT,WAAW;IACX,iFAAiF;AACrF;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,oCAAoC;IACpC,+BAA+B;IAC/B,yCAAyC;IACzC,0CAA0C;AAC9C","sourcesContent":["/* Chỉ áp dụng ẩn nút \"X\" khi component A mở */\n.gm-ui-hover-effect {\n    display: none !important;\n}\n\n.scrollable-div {\n    overflow-x: auto;\n    position: relative;\n}\n\n.scrollable-div.scrollable::after {\n    content: '';\n    position: absolute;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    width: 20px;\n    background: linear-gradient(to right, rgba(255, 255, 255, 0), rgba(0, 0, 0, 0.1));\n}\n\n.scrollable-div.not-scrollable::after {\n    display: none;\n}\n\n.row-selected {\n    background-color: #aed1ef !important;\n    border-color: yellow !important;\n    /* Màu nền tùy chỉnh cho hàng được chọn */\n    /* Màu viền tùy chỉnh cho hàng được chọn */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
